module.exports = __webpack_public_path__ + "img/LCRG_Swords_02.13b09e7f.png";